/**
 * @Author: 左建
 * @Date: 2022/6/27 13:59
 * @LastEditTime: 2022/6/27 13:59
 * @Description: 管理端相关接口
*/
// 管理后台侧边栏相关
export const sidebarRoutes = Object.freeze([
    {
        path: "psq",
        name: "ManagePsq",
        component: () => import("@/views/manage/psq/sidebar-psq/index"),
        meta: {
            title: "维普问卷",
            menuItemActive: 'psq',
            subMenuItem: '/manage/psq'
        }
    }
])

// 管理后台问卷相关
export const manageRoutes = Object.freeze([
    {
        path: "/manage/msq",
        name: "ManageMsq",
        component: () => import("@/views/manage/psq/msq"),
        meta: {
            title: "维普问卷"
        },
        children: [
            {
                path: "create",
                name: "ManageMsqCreate",
                component: () => import("@/views/manage/psq/msq/create"),
                meta: {
                    title: "创建问卷",
                    hidden: true
                },
            },
            {
                path: "create/text",
                name: "CreateTextImport",
                component: () => import("@/views/manage/psq/msq/create-text-import"),
                meta: {
                    title: "问卷文本导入",
                    hidden: true
                },
            },
            {
                path: "create/empty",
                name: "CreateEmpty",
                component: () => import("@/views/manage/psq/msq/create-empty"),
                meta: {
                    title: "问卷空白创建",
                    hidden: true
                },
            },
            {
                path: "stat",
                name: "Stat",
                component: () => import("@/views/manage/psq/msq/stat"),
                meta: {
                    title: "问卷统计",
                    hidden: true
                },
            }
        ]

    }
])
